import { render, staticRenderFns } from "./BugBounty.vue?vue&type=template&id=67d06ace&scoped=true&"
import script from "./BugBounty.vue?vue&type=script&lang=js&"
export * from "./BugBounty.vue?vue&type=script&lang=js&"
import style0 from "./BugBounty.vue?vue&type=style&index=0&id=67d06ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d06ace",
  null
  
)

export default component.exports